<div
  class="file-library"
  cdkDropList
  cdkDropListOrientation="mixed"
  (cdkDropListDropped)="handleDrop($event)"
>
  @for (file of listingFilesStateService.listingFilesState(); track $index) {
    <div
      class="file-library-card"
      cdkDrag
      cdkDragHandle
    >
      @if (file.usp) {
        <span
          tabindex="-1"
          class="file-library-card-usp"
          [matTooltip]="file.usp"
        >
          <mat-icon>info</mat-icon>
        </span>
      }
      <app-file-card
        class="app-file-card"
        [fileCard]="{
          id: file.id,
          fileParams: file.file,
          fileType: 'LISTING',
          isEditModeActive: isEditModeActive(),
          shouldCheckImageType: true
        }"
        [imgSize]="{
          width: '100%',
          height: '250px'
        }"
        [isNeedPreview]="true"
        [cardVariant]="'second'"
        (handleDelete)="handleDelete($event, file)"
      />
    </div>
  }
</div>
